export const SAVE = 'cashBankCardsTravelDocumentsAndPassportsStep.SAVE';
export const VALUE_CHANGED = 'cashBankCardsTravelDocumentsAndPassportsStep.VALUE_CHANGED';
export const LOAD = 'cashBankCardsTravelDocumentsAndPassportsStep.VALUE_LOAD';
export const NEXT = 'cashBankCardsTravelDocumentsAndPassportsStep.NEXT';
export const RESET = 'cashBankCardsTravelDocumentsAndPassportsStep.RESET';
//----------------------------------------------------
export const RESET_BANK_CARD_OR_TRAVEL_DOCUMENTS_STATE = 'cashBankCardsTravelDocumentsAndPassportsStep.RESET_BANK_CARD_OR_TRAVEL_DOCUMENTS_STATE';
export const RESET_CASH_STATE = 'cashBankCardsTravelDocumentsAndPassportsStep.RESET_CASH_STATE';

export const REPORT_TO = {
  POLICE: '1',
  HOTEL_MANAGEMENT: '2',
  CRUISE_SHIP: '3',
  AIRLINE: '4',
  TOUR_GUIDE: '5',
  OTHER: '6',
  NOT_REPORT: '20',
};

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.CashBankCardsTravelDocumentsAndPassports/constants.js